// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qr-floating-btn[data-v-e11be966]{position:absolute;top:14px;left:14px;z-index:20;background-color:hsla(0,0%,100%,.9)!important}", ""]);
// Exports
module.exports = exports;
